function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.686 2.948l2.115 2.115a.23.23 0 010 .323l-5.12 5.12-2.175.241a.456.456 0 01-.504-.504l.241-2.175 5.12-5.12a.23.23 0 01.323 0zm3.798-.537L12.34 1.267a.917.917 0 00-1.294 0l-.83.83a.23.23 0 000 .324l2.115 2.114c.089.09.234.09.323 0l.83-.83a.917.917 0 000-1.294zM9.25 9.113V11.5H1.75V3.998h5.387c.075 0 .145-.03.2-.082l.937-.937a.281.281 0 00-.2-.481h-6.7c-.62 0-1.124.504-1.124 1.125v8.252C.249 12.496.753 13 1.374 13h8.251c.622 0 1.126-.504 1.126-1.125v-3.7a.282.282 0 00-.48-.199l-.939.938a.288.288 0 00-.082.2z",
  fill: "currentColor"
});

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgEdit;